import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../material-ui/error_boundary/ErrorBoundary';

export default function ConfirmDialog({
  open,
  title = '',
  content = '',
  contentJSX = <></>,
  onClose,
  confirmText = 'Delete',
  onConfirm
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle variant="h2">{t(title)}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{content}</Typography>
        <ErrorBoundary>{contentJSX}</ErrorBoundary>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} fullWidth>
          {t('Cancel')}
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="error"
          onClick={() => {
            onConfirm();
            onClose();
          }}>
          {t(confirmText)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
